// extracted by mini-css-extract-plugin
export default {"highlight":"HighlightClickableText_highlight__G+AJH"};